import axios from 'axios'
import { apiEndpoints, contactApiEndpoints, crmLeadCreate as crmLeadCreateEndpoints } from '../constants'


export const getSessionId=async(lar,utm_source,utm_term,utm_campaign,language,dynamic_parameters=[])=>{
    try{
        const body={lar:lar,utm_source,utm_term,utm_campaign,language:language}
        if(dynamic_parameters && dynamic_parameters.length > 0){
            body.dynamic_parameters = dynamic_parameters;
        }
        const response=await axios.post(`${apiEndpoints.CREATE_SESSION}`,body);
        return response.data.session_id
    }catch(error){
        console.error('Error Creating Session',error)
    }
}

export const createApplication=async (sessionId,formType,lar,utm_source,utm_term,utm_campaign,language,dynamic_parameters=[])=>{
    try{
        const body={session_id:sessionId,form_type:formType,lar:lar,utm_source,utm_term,utm_campaign,language:language,form_data:{}}
        if(dynamic_parameters && dynamic_parameters.length > 0){
            body.dynamic_parameters = dynamic_parameters;
        }
        const response=await axios.post((`${apiEndpoints.CREATE_APPLICATION}`),body)
        return {application_Id:response.data?.application_id,session_Id:response.data?.session_id}
    }
    catch (error){
        console.log('Error creating the Appliocation Id',error)
    }
}

export const saveStepdata=async (stepData)=>{
    try{
        // Ensure dynamic_parameters is included if provided in stepData
        const requestBody = { ...stepData };
        if (!requestBody.dynamic_parameters) {
            requestBody.dynamic_parameters = [];
        }
        const response=await axios.post(
            `${apiEndpoints.SAVESTEP}`,requestBody
        )
        return response.data
    }
    catch(error){
        console.log('Error Saving The step:',error)
    }
}

export const assignContact = async (lar, phone) => {
    try{
        const email = lar ? `${lar}@bondstreetloans.com` : "";
        const body = { email, phone };
        const response = await axios.post(contactApiEndpoints.ASSIGN_CONTACT, body);
        return response.data;
    } catch(error){
        console.log('Error assigning contact:', error);
    }
}

export const crmLeadCreate = async (formData, formType, sessionId, applicationId, lar,dynamic_parameters=[]) => {
    try {
        const requestBody = {
            form_data: formData,
            form_type: formType,
            session_id: sessionId,
            application_id: applicationId,
            lar: lar
        };
         if(dynamic_parameters && dynamic_parameters.length > 0){
            requestBody.dynamic_parameters = dynamic_parameters;
        }
        const response = await axios.post(crmLeadCreateEndpoints.CREATE_LEAD, requestBody);
        return response.data;
    } catch(error){
        console.error('Error creating CRM lead:', error);
        throw error;
    }
}